import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../utils/api';
import toast from 'react-hot-toast';
import './Payment.css';

const UPI_ID = process.env.REACT_APP_UPI_ID || 'kubendiransys-1@oksbi';
const QR_URL = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=upi://pay?pa=${UPI_ID}%26pn=Suvaran+Maran+Matrimony%26am=499%26cu=INR`;

export default function Payment() {
  const { user, updateUser } = useAuth();
  const navigate = useNavigate();
  const [txnId, setTxnId] = useState('');
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(null);
  const [payment, setPayment] = useState(null);

  useEffect(() => {
    if (!user) return navigate('/login');
    API.get('/api/profiles/me').then(r => setProfile(r.data.profile)).catch(() => {});
    API.get('/api/payment/status').then(r => setPayment(r.data.payment)).catch(() => {});
  }, [user, navigate]);

  const handleSubmit = async () => {
    if (!txnId || txnId.trim().length < 8) return toast.error('Enter a valid Transaction ID (minimum 8 characters)');
    setLoading(true);
    try {
      const { data } = await API.post('/api/payment/submit', { transaction_id: txnId.trim() });
      toast.success(data.message);
      updateUser({ status: 'pending' });
      navigate('/pending');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to submit payment');
    }
    setLoading(false);
  };

  return (
    <div className="payment-page">
      <div className="payment-header">
        <div className="container">
          <h1>💳 Complete Your Payment</h1>
          <p>One-time payment to activate your profile</p>
        </div>
      </div>

      <div className="container payment-content">
        <div className="payment-grid">
          {/* Left: Summary */}
          <div className="payment-summary card" style={{padding:'32px'}}>
            <h2>📋 Registration Summary</h2>
            {profile ? (
              <div className="summary-items">
                <div className="si"><span>Name</span><strong>{profile.full_name}</strong></div>
                <div className="si"><span>Type</span><strong>{profile.profile_type === 'groom' ? '🤵 Groom' : '👰 Bride'}</strong></div>
                <div className="si"><span>Phone</span><strong>{user?.phone}</strong></div>
                <div className="si"><span>Horoscope</span><strong>{profile.horoscope_type}</strong></div>
                <div className="si"><span>Birth Star</span><strong>{profile.birth_star}</strong></div>
                <div className="si"><span>Rasi</span><strong>{profile.rasi}</strong></div>
                <div className="si"><span>Date</span><strong>{new Date().toLocaleDateString('en-IN')}</strong></div>
              </div>
            ) : (
              <div className="loader"><div className="spinner" /></div>
            )}

            <div className="payment-amount-box">
              <div className="pa-row"><span>Plan</span><span>Lifetime Membership</span></div>
              <div className="pa-row"><span>Amount</span><strong className="pa-amount">₹499</strong></div>
              <div className="pa-row pa-total"><span>Total</span><strong>₹499 (One Time Only)</strong></div>
            </div>
          </div>

          {/* Right: Payment */}
          <div className="payment-upi-section">
            <div className="card" style={{padding:'32px',marginBottom:'20px'}}>
              <h2>📱 Scan & Pay ₹499</h2>
              <p className="payment-instructions">Pay using any UPI app (Google Pay / PhonePe / Paytm / BHIM)</p>
              <div className="qr-wrap">
                <img src={QR_URL} alt="UPI QR Code" className="qr-img" />
                <div className="qr-upi-id">
                  <span>UPI ID:</span>
                  <strong>{UPI_ID}</strong>
                  <button className="copy-btn" onClick={() => { navigator.clipboard.writeText(UPI_ID); toast.success('UPI ID copied!'); }}>
                    📋 Copy
                  </button>
                </div>
              </div>
              <div className="pay-steps">
                {[
                  'Open any UPI app (Google Pay / PhonePe / Paytm)',
                  `Send ₹499 to UPI ID: ${UPI_ID}`,
                  'Copy the Transaction ID after payment',
                  'Paste the Transaction ID below',
                  'Click "Confirm Payment"',
                ].map((s, i) => (
                  <div key={i} className="pay-step-item">
                    <span className="psi-num">{i+1}</span>
                    <span>{s}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="card" style={{padding:'32px'}}>
              <h2>✅ Confirm Your Payment</h2>
              <p style={{color:'var(--brown)',marginBottom:'20px',fontSize:'0.9rem'}}>
                After paying ₹499, enter the UPI Transaction ID below
              </p>
              <div className="form-group">
                <label className="form-label">UPI Transaction ID *</label>
                <input
                  className="form-input"
                  value={txnId}
                  onChange={e => setTxnId(e.target.value)}
                  placeholder="Enter Transaction ID (e.g. 123456789012)"
                  style={{fontSize:'16px',letterSpacing:'1px'}}
                />
                <p className="form-error" style={{color:'var(--brown)'}}>
                  ℹ️ Transaction ID is shown in your UPI app after payment
                </p>
              </div>
              <button className="btn btn-gold btn-lg" style={{width:'100%'}} onClick={handleSubmit} disabled={loading}>
                {loading ? <><span className="spinner" style={{width:18,height:18}} /> Submitting...</> : '✅ Confirm Payment'}
              </button>
              <div className="payment-notice">
                <p>⏳ Admin will verify your payment within <strong>24 hours</strong></p>
                <p>📱 You will be notified once your profile is approved</p>
                <p>❓ For help: <a href="tel:+91 9842724724">+91 9842724724</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
